import Box from '@mui/material/Box';
import PayloadBuilder from '../../components/PayloadBuilder/PayloadBuilder';
import { readableStepName, escapeEmptyDetail } from '../../utils/utils';
import DetailItem from '../../components/DetailItem/DetailItem';
import {StakeholdersDetails} from "../../components/StakeholdersDetails/StakeholdersDetails";
import React from "react";

export const AssetRegistrationEventModel = (event) => {
    return (
    <>
      <Box
        sx={{
          width: '100%',
          border: '1px solid lightgrey',
          borderRadius: '4px',
          padding: '20px',
          marginBottom: '20px',
          display: 'block',
      }}>
        <p className='details-title'>
          <b>
            {
              readableStepName(event['@type'])
            }
          </b>
        </p>
        <DetailItem title='Title' content={escapeEmptyDetail(event.title)} />
        <DetailItem title='Description' content={escapeEmptyDetail(event.description)} />
        <DetailItem title='Name' content={readableStepName(event['@type'])} />
          <StakeholdersDetails oldStakeholders={event.oldCustodians} />
        <DetailItem title='Registry Account Id' content={escapeEmptyDetail(event.registryAccountId)} copy={event.registryAccountId} />
        <DetailItem title='Registry Account Name' content={escapeEmptyDetail(event.registryAccountname)} />
        <DetailItem title='Registry' content={escapeEmptyDetail(event.registry)} />
        <DetailItem title='Registry Provider' content={escapeEmptyDetail(event.registryProvider)} />
        <DetailItem title='Registry Environment' content={escapeEmptyDetail(event.registryEnvironment)} />
        <DetailItem title='Registry API Version' content={escapeEmptyDetail(event.registryAPIVersion)} />
        <DetailItem title='Created at' content={event.createdAt.split('T', 1) + ' ' + event.createdAt.split('T', 2)[1].split('.', 1)+' (GMT)'} />
      </Box>
      <Box
        sx={{
          width: '100%',
          border: '1px solid lightgrey',
          borderRadius: '4px',
          padding: '20px',
          marginBottom: '20px',
          display: 'block',
      }}>

          { event.payload &&
              <PayloadBuilder payload={event.payload} />
          }
      </Box>
    </>
  );
};
